var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLocationPin = function SvgLocationPin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_29715)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.00002,
    cy: 5.79104,
    r: 4.03713,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64268 13.4416C7.2762 13.7676 6.72467 13.7676 6.3582 13.4416C4.79908 12.0545 3.61035 10.756 2.792 9.54598C1.86426 8.17537 1.40039 6.90672 1.40039 5.74005C1.40039 3.99003 1.96343 2.59585 3.0895 1.55751C4.21511 0.519171 5.51876 0 7.00044 0C8.48211 0 9.78599 0.519171 10.9121 1.55751C12.0377 2.59585 12.6005 3.99003 12.6005 5.74005C12.6005 6.90672 12.1366 8.17537 11.2089 9.54598C10.3905 10.756 9.20179 12.0545 7.64268 13.4416Z",
    fill: "#4C8CEB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.00039,
    cy: 5.6,
    r: 2.1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_29715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLocationPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "location-pin.72362d5efdda6c94c3e86842fd927905.svg";